import React, { useEffect } from 'react'
import classes from './Map.module.css'
import './Cluster.css'
import L from 'leaflet'
import 'leaflet-fullscreen'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet/dist/leaflet.css';
// import ReactDOMServer from 'react-dom/server';
import SubSectionHeader from '../../Shared/SubSectionHeader'
import 'leaflet-polylinedecorator'

let map, map2, mcg, customDescription2 = undefined;

const Map = ({ data = [], network = [] }) => {
  useEffect(() => {
    InitializeMap()
    addTiletoMap()
    document.getElementById('branchmaptab').click()

  }, [])
  useEffect(() => {
    createClusterGroup()
    if (map2)
      plotNetwork()

  })
  const InitializeMap = () => {
    map = L.map('companymap', {
      center: [20.5937, 78.9629],
      zoom: 4.5,
      maxZoom: 6,
      minZoom: 4,
      zoomSnap: 0.5,
      zoomControl: false,
      zoomDelta: 0.5
    });
    L.control.fullscreen({
      position: 'topright', // change the position of the button can be topleft, topright, bottomright or bottomleft, defaut topleft
      forcePseudoFullscreen: true

    }).addTo(map);
    map2 = L.map('companylane', {
      center: [20.5937, 78.9629],
      zoom: 4.5,
      maxZoom: 6,
      minZoom: 4,
      zoomSnap: 0.5,
      zoomControl: false,
      zoomDelta: 0.5
    });
    L.control.fullscreen({
      position: 'topright', // change the position of the button can be topleft, topright, bottomright or bottomleft, defaut topleft
      forcePseudoFullscreen: true

    }).addTo(map2);
  }
  const addTiletoMap = () => {
    // Previous tile provider (CARTO) - now requires an API key, kept for reference
    // L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
    //   attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    //   subdomains: 'abcd',
    //   maxZoom: 19
    // }).addTo(map);
    L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
      {
        attribution:
          "Esri, HERE, Garmin, &copy; OpenStreetMap contributors, and the GIS user community",
        maxZoom: 19,
      }
    ).addTo(map);
    // Previous tile provider (CARTO) - now requires an API key, kept for reference
    // L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
    //   attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    //   subdomains: 'abcd',
    //   maxZoom: 19
    // }).addTo(map2);
    L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
      {
        attribution:
          "Esri, HERE, Garmin, &copy; OpenStreetMap contributors, and the GIS user community",
        maxZoom: 19,
      }
    ).addTo(map2);
  }
  const plotNetwork = () => {
    if (network.length !== 0) {

      for (let i = 0; i < network.length; i++) {
        let orginLatLng = new L.latLng([network[i].origin.lat, network[i].origin.lon])
        let destinationLatLng = new L.latLng([network[i].destination.lat, network[i].destination.lon])
        var line = new L.polyline([orginLatLng, destinationLatLng], { color: '#007AFF', weight: 1, opacity: 0.3 })
        line.addTo(map2)

        L.polylineDecorator(line, {
          patterns: [
            {
              endOffset: '0%',
              offset: '53%',
              repeat: '0%',
              symbol: L.Symbol.arrowHead({
                pixelSize: 6,
                polygon: false,
                pathOptions: { opacity: 0.3, weight: 2, stroke: true, color: '#007AFF' }
              })
            }
          ]
        }).addTo(map2)

      }
    }
  }
  const createClusterGroup = () => {
    let BranchData = []
    data.map(item =>
      BranchData.push({
        locations: [item]
      }))
    const features = createFeatureCollection(BranchData)
    mcg = L.markerClusterGroup({
      iconCreateFunction: function (cluster) {
        var childCount = cluster.getChildCount();
        var c = ' marker-cluster1-';
        if (childCount < 1) {
          c += 'small1';
        } else if (childCount < 100) {
          c += 'medium1';
        } else {
          c += 'large1';
        }

        return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', className: 'marker-cluster1' + c, iconSize: new L.Point(20, 20) });

      },
      chunkedLoading: true,
      singleMarkerMode: true,
      spiderfyOnMaxZoom: true,
      maxClusterRadius: 25,
      spiderLegPolylineOptions: { weight: 3, color: 'red', opacity: 0.75 }
    });
    for (let i = 0; i < features.length; i++) {

      var marker = L.marker(new L.LatLng(features[i].geometry.coordinates[1], features[i].geometry.coordinates[0]));
      marker.bindPopup(features[i].properties.description)
      let isclicked = false;
      marker.on('mouseover', function (ev) {
        isclicked = false;
        ev.target.openPopup();
      })
      marker.on('mouseout', function (ev) {
        if (!isclicked)
          ev.target.closePopup();
      })
      marker.on('click', function (ev) {
        isclicked = true;
        ev.target.openPopup();
      })
      mcg.addLayer(marker);
    }
    if (map)
      map.addLayer(mcg);
  }
  const createFeatureCollection = locationsToDisplay => {
    let features = [];

    var uniqueLocations = locationsToDisplay;

    for (var i = 0; i < uniqueLocations.length; i++) {
      let location = uniqueLocations[i];

      if (
        !location.locations ||
        !location.locations.length ||
        !location.locations[0].lon ||
        !location.locations[0].lat ||
        location.locations[0].lon === 'NA' ||
        location.locations[0].lat === 'NA'
      ) {
        continue;
      }

      var iconType = (i === 0) ? "marker" : "markerbranch";

      let feature = {
        type: 'Feature',
        properties: {
          description: customDescription2 || `<div>
              <h5>
                ${location.locations[0].location},${' '}
                ${location.locations[0].state}
              </h5>
              <h6 />
            </div>`,
          icon: iconType
        },
        geometry: {
          type: 'Point',
          coordinates: [location.locations[0].lon, location.locations[0].lat]
        }

      };

      features.push(feature);
    }

    return features;
  };
  // const  customDescription = locationData => {
  //     return ReactDOMServer.renderToStaticMarkup(
  //       <div>
  //         <h5>
  //           {locationData.locations[0].location},{' '}
  //           {locationData.locations[0].state}
  //         </h5>
  //         <h6 />
  //       </div>
  //     );
  //   };
  const openCity = (evt, cityName) => {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    window.dispatchEvent(new Event('resize'));

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
    if (cityName === 'companymap') {
      map.setView([20.5937, 78.9629], 4.5)
    }
    else {
      map2.setView([20.5937, 78.9629], 4.5)

    }
  }
  return (
    <div className={classes['Container']}>
      <SubSectionHeader title="Plant Locations" className={classes['title']}></SubSectionHeader>
      <div className="tab">
        <button style={{ color: '#393185' }} className="tablinks active" id="branchmaptab" onClick={e => openCity(e, 'companymap', map, map2)}>Branch List</button>
        <button style={{ color: '#393185' }} className="tablinks" onClick={e => openCity(e, 'companylane', map, map2)}>Operating Lanes</button>
      </div>
      <div id="companymap" className={`tabcontent ${classes['CompanyMap']}`}></div>
      <div id="companylane" style={{ display: 'none' }} className={`tabcontent ${classes['Companylane']}`}></div>
    </div>
  )
}



export default Map
